/* Moonou Gift Picker — Aktionsart "Zugabe zur Auswahl" (promo_type gift_pick).
 *
 * Fängt den ATC-Submit auf jeder Produktseite ab, die das Modal rendert
 * (Capture-Phase auf document, damit der Handler VOR dem
 * theme.js-ProductForm-Listener läuft), prüft die Mindestanzahl, öffnet das
 * Auswahl-Modal und schickt danach EINEN POST /cart/add.js mit items-Array
 * (ggf. Addon-Bundles + Hauptprodukt + Geschenk mit _gift-Property).
 * Danach Standard-Theme-Flow: cartUpdate-Event publizieren + Cart Drawer öffnen.
 *
 * Das Modal kommt seit der Umstellung auf das generische Aktions-System aus
 * layout/theme.liquid und existiert pro Seite genau einmal — unabhängig
 * davon, welche Buybox-Section die Produktseite baut. Es nennt deshalb nicht
 * mehr die Formular-ID, sondern die Produkt-ID (data-mgp-product); die
 * Zuordnung zum Formular passiert hier, zur Event-Zeit (findModalForForm).
 *
 * Bedingung der Zugabe: entweder ab N Zielprodukten (promo_gift_rule 'units',
 * Schwelle promo_gift_min_units) oder ab einem Mindest-Bestellwert
 * (promo_gift_rule 'subtotal', Schwelle promo_gift_min_subtotal). Gerechnet
 * wird beide Male, was schon im Warenkorb liegt, plus was dieses Formular
 * gerade zulegt. Die Einordnung jeder Warenkorbzeile macht Liquid
 * (snippets/moonou-promo-cart-state.liquid) — hier steht nur die Summierung.
 * Sie ist bewusst eine eigene, kleine Kopie der Regeln aus
 * assets/moonou-promo-gift.js: der Zugabe-Motor ist bei dieser Aktionsart gar
 * nicht geladen, und beide Skripte sollen laut Spec getrennt bleiben. Die
 * Wortgleichheit beider Kopien sichert tests/promo-gift.test.cjs ab, indem es
 * cartSubtotal() aus BEIDEN Dateien gegen dieselben Warenkoerbe rechnet.
 *
 * Architektur: reine Event-Delegation auf document-Ebene. Modal und Formular
 * werden ZUR EVENT-ZEIT über das Attribut data-mgp-form aufgelöst — keine
 * gecachten Element-Referenzen. Grund: Der Theme-Editor rendert die Section
 * bei jeder Setting-Änderung neu (shopify:section:load); gecachte Referenzen
 * wären danach stale und der Intercept still tot.
 *
 * Fallback bei jedem Fehler: Bypass-Flag ans Formular und normal submitten
 * (theme.js-ProductForm übernimmt) — kein Kunde bleibt hängen. Jede
 * Bail-Stelle loggt ein console.warn mit Grund, damit QA sofort sieht,
 * WARUM das Popup nicht kam.
 */
(function () {
  if (window.MoonouGiftPicker) return;
  window.MoonouGiftPicker = true;

  /* Die Aktions-Kennung kommt aus data-mgp-gift-key am Modal (Theme-
     Einstellung promo_key) und ist Pflicht. Sie wird als Warenkorb-Property
     _gift geschrieben und ist der einzige Schluessel, an dem der Zugabe-Motor
     (assets/moonou-promo-gift.js) eine Zugabe spaeter wiedererkennt und
     aufraeumt. Es gibt bewusst KEINEN Rueckfallwert: ein erfundener Schluessel
     wuerde eine Zugabe erzeugen, die nie wieder aufgeraeumt wird. Fehlt die
     Kennung, haelt sich der Picker komplett raus (siehe
     modalInactiveReason) und der ATC laeuft als normaler Kauf durch. */
  function giftPropertyValue(modal) {
    var key = modal && modal.getAttribute('data-mgp-gift-key');
    return (key && key.trim()) || '';
  }
  var BYPASS_ATTR = 'data-mgp-bypass';
  var PENDING_ATTR = 'data-mgp-pending';

  /* --- Mindestanzahl --------------------------------------------------- */

  /* Warenkorb-Schnappschuss aus dem Liquid-Snippet. Beim Laden der Seite
     gerendert und nach jedem Warenkorb-Ereignis im Hintergrund nachgeladen,
     damit der Intercept selbst ohne Wartezeit auskommt. */
  var cartItems = readCartItems(document);
  var cartRefreshing = false;

  function readCartItems(doc) {
    var el = doc.querySelector('[data-promo-cart-state]');
    if (!el) return null;
    try {
      var state = JSON.parse(el.textContent);
      return Array.isArray(state.items) ? state.items : null;
    } catch (err) {
      warn('Warenkorb-Status nicht lesbar — Mindestanzahl wird nicht geprüft.');
      return null;
    }
  }

  function refreshCartItems() {
    if (cartRefreshing) return;
    cartRefreshing = true;
    fetch(window.location.pathname, { cache: 'no-store', headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var fresh = readCartItems(new DOMParser().parseFromString(html, 'text/html'));
        if (fresh) cartItems = fresh;
      })
      .catch(function (error) {
        warn('Warenkorb-Status nicht aktualisierbar (' + error.message + ') — es gilt der Stand beim Seitenaufruf.');
      })
      .finally(function () {
        cartRefreshing = false;
      });
  }

  /* Gekauft heisst: bezahlt, keine Zugabe, kein Gratis-Artikel aus dem
     Bundle-Konfigurator. Wortgleich zur Regel im Zugabe-Motor. */
  function isPurchased(item) {
    return item.paid && !item.gift && item.bundleRole !== 'gratis';
  }

  /* Sockel + Schirm derselben Gruppe ergeben zusammen EINE Einheit; die
     2-Stueck-Variante traegt units = 2. Wortgleich zu countLamps() im
     Zugabe-Motor (assets/moonou-promo-gift.js) — beide lesen dieselben
     kind/units/paid-Werte aus snippets/moonou-promo-cart-state.liquid. */
  function countCartUnits(items) {
    if (!items) return 0;
    var count = 0;
    var assemblies = {};
    items.forEach(function (item) {
      if (!isPurchased(item)) return;
      if (item.kind === 'lamp') count += item.quantity * item.units;
      if (item.kind !== 'base' && item.kind !== 'shade') return;
      var group = item.group || 'legacy';
      if (!assemblies[group]) assemblies[group] = { base: 0, shade: 0 };
      assemblies[group][item.kind] += item.quantity;
    });
    Object.keys(assemblies).forEach(function (group) {
      count += Math.min(assemblies[group].base, assemblies[group].shade);
    });
    return count;
  }

  /* „Nur Schirm" heisst: kein Sockel im Warenkorb, also auch keine ganze
     Einheit. Denselben Umschalter liest der Zugabe-Motor in updateMode(). */
  function shadeOnlyMode(form) {
    var section = form.closest && form.closest('.shopify-section');
    var picker = section && section.querySelector('moonou-mode-picker');
    return !!picker && picker.mode === 'schirm';
  }

  /* Was dieses Formular gerade zulegt, in Zähleinheiten gerechnet. */
  function formUnits(modal, form) {
    var kind = modal.getAttribute('data-mgp-self-kind') || 'lamp';
    if (kind === 'base') return 0;
    if (kind === 'shade' && shadeOnlyMode(form)) return 0;

    var data = new FormData(form);
    var quantity = parseInt(data.get('quantity') || '1', 10) || 1;
    /* Doppelpackungen zaehlen bei SCHIRMEN bewusst als eine Einheit je Stueck,
       die Varianten-Karte bleibt hier aussen vor. Grund: Im Modus „Komplette
       Lampe" traegt die versteckte Sockel-Zeile die Formular-Stueckzahl, nicht
       die Packungsgroesse (prepareFormData in assets/theme.js) - zu einer
       2er-Schirmpackung gehoert also genau EIN Sockel und damit eine ganze
       Lampe. Dieselbe Regel zieht snippets/moonou-promo-cart-state.liquid im
       Warenkorb: dort greift units = 2 ebenfalls nur bei kind == 'lamp'.
       Wer das aendert, muss BEIDE Stellen aendern. */
    if (kind === 'shade') return quantity;

    var units = 1;
    try {
      var map = JSON.parse(modal.getAttribute('data-mgp-units-map') || '{}');
      var fromMap = map[String(data.get('id'))];
      if (typeof fromMap === 'number' && fromMap > 0) units = fromMap;
    } catch (err) {
      /* Kaputte Karte = konservativ 1 Einheit, nie mehr. */
    }
    return quantity * units;
  }

  /* --- Bedingung „Ab Bestellwert" --------------------------------------- */

  /* Schwelle in Cent. Ein unbrauchbarer Wert (fehlt, keine Zahl, kleiner 1)
     heisst NIE erfuellt: eine Zugabe zu verschenken, weil eine Zahl fehlt, ist
     der teurere Fehler. Wortgleiche Regel im Zugabe-Motor
     (assets/moonou-promo-gift.js, minSubtotal()). */
  function minSubtotalOf(modal) {
    var value = Number(modal.getAttribute('data-mgp-min-subtotal'));
    return isFinite(value) && value >= 1 ? value : Infinity;
  }

  /* Bestellwert des Warenkorbs in Cent. Alles zaehlt ausser der eigenen Zugabe
     und Gratis-Zeilen aus dem Bundle-Konfigurator. Wortgleich zu cartSubtotal()
     im Zugabe-Motor — dieselben price/gift/bundleRole-Werte aus
     snippets/moonou-promo-cart-state.liquid.

     Die eigene Zugabe MUSS draussen bleiben: zaehlte sie mit, hielte sie sich
     nach dem Hinzufuegen selbst ueber der Schwelle. */
  function cartSubtotal(items, key) {
    if (!items) return 0;
    var total = 0;
    items.forEach(function (item) {
      if (key && item.gift === key) return;
      if (item.bundleRole === 'gratis') return;
      /* Nur Aktionsprodukte, wortgleich zu countsForSubtotal in
         assets/moonou-promo-gift.js: Shopifys BXGY misst seine Kaufbedingung
         ebenfalls nur an den ausgewaehlten Aktionsprodukten. */
      if (item.kind === 'other') return;
      var price = Number(item.price);
      if (isFinite(price) && price > 0) total += price;
    });
    return total;
  }

  /* Wert dessen, was dieses Formular gerade zulegt, in Cent — das Gegenstueck
     zu formUnits(). Anders als dort spielt die Art keine Rolle: der Bestellwert
     fragt nicht nach Lampen, sondern nach Geld, ein Sockel zaehlt also mit.

     Bewusst unvollstaendig nach unten: angehakte Zusatz-Lampenschirme
     (bundles-Checkboxen) bleiben aussen vor, weil ihre Preise hier nicht
     vorliegen. Die Schwelle wird dadurch im Zweifel spaeter erreicht, nie
     frueher — und was der Warenkorb danach wirklich enthaelt, misst ohnehin
     Shopifys Rabattregel.

     Eine Einschraenkung nach OBEN gibt es allerdings, und sie gilt nur hier:
     die Preise stammen aus dem Markup (snippets/moonou-gift-picker.liquid,
     v.price und settings.moonou_base_product.price), also VOR automatischen
     Rabatten. Der Warenkorb-Zustand und der Zugabe-Motor rechnen dagegen mit
     item.final_line_price, also NACH Zeilenrabatten. Laeuft eine Prozent-
     Aktion oder ein BXGY-Code des Bundle-Konfigurators, schaetzt diese Zeile
     also zu hoch und die Zugabe kann zugelegt werden, obwohl Shopify sie nicht
     gratis stellt. Verschaerfend: bei der Aktionsart „Zugabe zur Auswahl" ist
     der Zugabe-Motor gar nicht geladen (layout/theme.liquid laedt
     moonou-promo-gift.js nur im Zweig promo_type == 'gift'), es raeumt also
     niemand nach. Wer promo_type auf 'gift_pick' stellt, WAEHREND ein
     automatischer Rabatt laeuft, muss den Motor dort mitladen — sonst zahlt
     der Kunde die Zugabe. */
  function formSubtotal(modal, form) {
    var data = new FormData(form);
    var quantity = parseInt(data.get('quantity') || '1', 10) || 1;
    var price = 0;
    try {
      var map = JSON.parse(modal.getAttribute('data-mgp-price-map') || '{}');
      var fromMap = map[String(data.get('id'))];
      if (typeof fromMap === 'number' && fromMap > 0) price = fromMap;
    } catch (err) {
      /* Kaputte Karte = 0 Cent, nie mehr. */
    }
    /* Im Modus „Komplette Lampe" haengt an jedem Schirm eine versteckte
       Sockel-Zeile mit derselben Stueckzahl (prepareFormData in
       assets/theme.js). Ihr Preis gehoert zum Bestellwert, sonst faenden zwei
       Komplettlampen die 99-Euro-Schwelle nie. */
    var kind = modal.getAttribute('data-mgp-self-kind') || 'lamp';
    if (kind === 'shade' && !shadeOnlyMode(form)) {
      price += parseInt(modal.getAttribute('data-mgp-base-price') || '0', 10) || 0;
    }
    return quantity * price;
  }

  /* Reicht der Warenkorb fuer die Zugabe? Liefert den Bail-Grund oder null.
     Die Fallunterscheidung ist wortgleich zu qualifies() im Zugabe-Motor:
     Regel 'subtotal' vergleicht Bestellwerte, alles andere zaehlt Lampen. */
  function belowMinimumReason(modal, form) {
    if (modal.getAttribute('data-mgp-rule') === 'subtotal') {
      var minValue = minSubtotalOf(modal);
      var sum = cartSubtotal(cartItems, giftPropertyValue(modal)) + formSubtotal(modal, form);
      if (sum >= minValue) return null;
      return 'Mindest-Bestellwert nicht erreicht (' + sum + ' von ' + minValue + ' Cent)';
    }
    var min = parseInt(modal.getAttribute('data-mgp-min-units') || '', 10);
    if (!min || min < 1) return null; /* Keine Schwelle gesetzt = jede Menge genuegt. */
    var total = countCartUnits(cartItems) + formUnits(modal, form);
    if (total >= min) return null;
    return 'Mindestanzahl nicht erreicht (' + total + ' von ' + min + ')';
  }

  function warn(reason) {
    console.warn('[gift-picker] ' + reason);
  }

  /* Start/Deadline aus den data-launch-promo-Attributen des Modals.
     Bevorzugt Unix-Timestamps (zeitzonen-sicher), ISO-Strings als Fallback.
     Fehlender/leerer Start = sofort aktiv, fehlendes Ende = kein Ablauf. */
  function parseAttrTime(modal, isoAttr, tsAttr) {
    var ts = modal.getAttribute(tsAttr);
    var iso = modal.getAttribute(isoAttr);
    var time = NaN;
    if (ts) time = parseInt(ts, 10) * 1000;
    if (isNaN(time) && iso) time = new Date(iso).getTime();
    return time;
  }

  function modalExpired(modal) {
    if (window.MoonouLaunchPromo) return window.MoonouLaunchPromo.isElementExpired(modal);
    var time = parseAttrTime(modal, 'data-launch-promo-deadline', 'data-launch-promo-deadline-ts');
    return !isNaN(time) && time <= Date.now();
  }

  function modalNotStarted(modal) {
    if (window.MoonouLaunchPromo) return !window.MoonouLaunchPromo.isElementStarted(modal);
    var time = parseAttrTime(modal, 'data-launch-promo-start', 'data-launch-promo-start-ts');
    return !isNaN(time) && time > Date.now();
  }

  /* Aktion nicht einsatzbereit (Kennung fehlt, noch nicht gestartet ODER
     abgelaufen)? Liefert den Bail-Grund als String für die QA-Warnung, sonst
     null. Wird zweimal geprüft: beim Intercept und direkt vor dem Cart-Call. */
  function modalInactiveReason(modal) {
    if (!giftPropertyValue(modal)) {
      return 'Keine Aktions-Kennung am Modal (Theme-Einstellung promo_key ist leer)';
    }
    if (modalNotStarted(modal)) {
      return 'Aktion noch nicht gestartet (start=' + modal.getAttribute('data-launch-promo-start') + ')';
    }
    if (modalExpired(modal)) {
      return 'Aktion abgelaufen (deadline=' + modal.getAttribute('data-launch-promo-deadline') + ')';
    }
    return null;
  }

  function cssEscape(value) {
    return window.CSS && CSS.escape ? CSS.escape(value) : value;
  }

  /* Die ID eines FORMULARS immer über getAttribute lesen: Shopify-ATC-Forms
     enthalten <input name="id"> (Varianten-ID), und HTMLFormElement-Named-
     Properties ([OverrideBuiltins]) überschatten form.id — form.id liefert
     dann das INPUT-ELEMENT statt des ID-Strings. Der daraus gebaute Selector
     x-modal[data-mgp-form="[object HTMLInputElement]"] matcht nie -> der
     Intercept war still tot (Root Cause des "Popup öffnet nicht"-Bugs). */
  function formId(form) {
    return (form && form.getAttribute && form.getAttribute('id')) || '';
  }

  /* Gehört das Formular zum Produkt des globalen Modals? Die Buybox-Sections
     bauen ihre Formular-ID als ProductForm-<Section-ID>-<Produkt-ID>, das
     Suffix ist damit der Produktbezug. Das Trennzeichen muss mit: ohne den
     Bindestrich träfe die Produkt-ID 123 auch in ProductForm-abc-9123. */
  function formBelongsToProduct(id, productId) {
    if (!productId) return false;
    if (id.indexOf('ProductForm-') !== 0) return false;
    return id.slice(-(productId.length + 1)) === '-' + productId;
  }

  /* Modal zum Formular auflösen — zur Event-Zeit, nie gecacht. Zwei Wege:
     1. Ein Modal, das genau dieses Formular nennt (data-mgp-form). Das gibt
        es nur, wenn eine Section das Modal mit fester Formular-ID rendert.
     2. Das globale Modal aus layout/theme.liquid. Es kennt beim Rendern nur
        die Produkt-ID; passt das Formular dazu, merkt es sich dessen ID,
        damit Skip-Link und Cart-Call später dasselbe Formular wiederfinden.
     Reihenfolge mit Absicht: ein Section-Modal ist enger gebunden und
     gewinnt, solange die Umstellung nicht überall durch ist. */
  function findModalForForm(form) {
    var id = formId(form);
    if (!id) return null;
    var bound = document.querySelector('x-modal[data-mgp-form="' + cssEscape(id) + '"]');
    if (bound) return bound;
    var globalModal = document.querySelector('x-modal[data-mgp-modal][data-mgp-product]');
    if (!globalModal) return null;
    if (!formBelongsToProduct(id, globalModal.getAttribute('data-mgp-product'))) return null;
    globalModal.setAttribute('data-mgp-form', id);
    return globalModal;
  }

  function findFormForModal(modal) {
    return document.getElementById(modal.getAttribute('data-mgp-form'));
  }

  function closeModal(modal) {
    if (modal && typeof modal.hide === 'function') modal.hide();
  }

  /* Normaler ATC ohne Gift: Bypass-Flag setzen, damit der Capture-Listener
     das Submit durchlässt und theme.js-ProductForm übernimmt. */
  function submitNative(form) {
    if (!form) return;
    form.setAttribute(BYPASS_ATTR, 'true');
    try {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    } catch (err) {
      form.removeAttribute(BYPASS_ATTR);
      console.error('[gift-picker] native submit failed', err);
    }
  }

  /* --- 1. ATC-Intercept (Capture-Phase, läuft vor theme.js ProductForm) --- */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      var modal = findModalForForm(form);
      if (!modal) return; /* Formular ohne Gift-Picker -> nicht unser Fall, kein Log */

      if (form.hasAttribute(BYPASS_ATTR)) {
        form.removeAttribute(BYPASS_ATTR);
        warn('Bypass aktiv — Submit läuft als normaler ATC durch (gewollt).');
        return;
      }
      var inactiveReason = modalInactiveReason(modal);
      if (inactiveReason) {
        warn(inactiveReason + ' — normaler ATC.');
        return;
      }
      if (typeof modal.show !== 'function') {
        warn('x-modal Web Component (noch) nicht upgegradet — normaler ATC. Lädt theme.js?');
        return;
      }
      if (!modal.querySelector('[data-mgp-variant]:not([disabled])')) {
        warn('Kein verfügbares Geschenk im Modal (Auswahlkarten leer oder alles ausverkauft) — normaler ATC.');
        return;
      }
      var belowMinimum = belowMinimumReason(modal, form);
      if (belowMinimum) {
        warn(belowMinimum + ' — normaler ATC ohne Geschenk.');
        return;
      }
      if (modal.hasAttribute(PENDING_ATTR)) {
        warn('Cart-Call läuft bereits — Submit ignoriert (Doppel-Add-Schutz).');
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      /* Ab hier ist der native Submit verhindert — show() darf den Kunden
         bei einem synchronen Fehler nicht hängen lassen (Review #2). */
      try {
        modal.show(event.submitter || form);
      } catch (err) {
        console.error('[gift-picker] modal.show() fehlgeschlagen — Fallback auf normalen ATC.', err);
        submitNative(form);
      }
    },
    true
  );

  /* --- 2. Klicks im Modal (Karte wählen / ohne Geschenk fortfahren) --- */
  document.addEventListener('click', function (event) {
    var skip = event.target.closest && event.target.closest('[data-mgp-skip]');
    if (skip) {
      var skipModal = skip.closest('x-modal[data-mgp-modal]');
      if (!skipModal) return;
      event.preventDefault();
      if (skipModal.hasAttribute(PENDING_ATTR)) {
        warn('Cart-Call läuft bereits — Skip-Link ignoriert (Doppel-Add-Schutz).');
        return;
      }
      closeModal(skipModal);
      submitNative(findFormForModal(skipModal));
      return;
    }

    var card = event.target.closest && event.target.closest('[data-mgp-variant]');
    if (!card) return;
    var modal = card.closest('x-modal[data-mgp-modal]');
    if (!modal || card.disabled) return;
    event.preventDefault();
    if (modal.hasAttribute(PENDING_ATTR)) {
      warn('Cart-Call läuft bereits — Kartenklick ignoriert (Doppel-Add-Schutz).');
      return;
    }
    addWithGift(modal, card);
  });

  /* --- 3. Ein Cart-Call mit beiden Positionen --- */
  function addWithGift(modal, card) {
    var form = findFormForModal(modal);
    if (!form) {
      warn('Formular #' + modal.getAttribute('data-mgp-form') + ' nicht gefunden — Abbruch.');
      closeModal(modal);
      return;
    }

    /* Review #1: Aktion kann ablaufen (oder war noch nicht gestartet),
       WÄHREND das Modal offen ist — dann wäre das "Gratis"-Produkt voll
       berechnet (Discount serverseitig weg/noch nicht aktiv). Deshalb
       direkt vor dem Cart-Call erneut prüfen. */
    var inactiveReason = modalInactiveReason(modal);
    if (inactiveReason) {
      warn(inactiveReason + ' (Prüfung vor Cart-Call) — normaler ATC ohne Gift.');
      closeModal(modal);
      submitNative(form);
      return;
    }

    /* Menge kann sich geaendert haben, waehrend das Modal offen war (Mengen-
       feld, Varianten-Wechsel, Warenkorb in einem zweiten Tab). Sonst waere
       das Geschenk voll berechnet, weil die Rabattregel nicht greift. */
    var belowMinimum = belowMinimumReason(modal, form);
    if (belowMinimum) {
      warn(belowMinimum + ' (Prüfung vor Cart-Call) — normaler ATC ohne Geschenk.');
      closeModal(modal);
      submitNative(form);
      return;
    }

    var giftVariantId = card.getAttribute('data-mgp-variant');
    var atcFormId = formId(form);
    var submitButton =
      form.querySelector('[type="submit"]') ||
      document.querySelector('[type="submit"][form="' + cssEscape(atcFormId) + '"]');

    /* Review #3: modal-weites Pending-Flag — blockt alle Karten UND den
       Skip-Link, solange ein Cart-Call läuft (sonst Doppel-Add möglich).
       Visuell: Badge der gewählten Karte wird zum "Wird hinzugefügt …"-Label
       (Text aus data-mgp-busy-label), übrige Karten dimmen per CSS. */
    var badge = card.querySelector('.moonou-gift-picker__item-badge');
    function setBusy(busy) {
      if (busy) {
        modal.setAttribute(PENDING_ATTR, 'true');
        card.setAttribute('aria-busy', 'true');
        if (badge) {
          badge.setAttribute('data-mgp-label', badge.textContent);
          badge.textContent = modal.getAttribute('data-mgp-busy-label') || 'Wird hinzugefügt …';
        }
        if (submitButton) {
          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.setAttribute('aria-busy', 'true');
        }
      } else {
        modal.removeAttribute(PENDING_ATTR);
        card.removeAttribute('aria-busy');
        if (badge && badge.hasAttribute('data-mgp-label')) {
          badge.textContent = badge.getAttribute('data-mgp-label');
          badge.removeAttribute('data-mgp-label');
        }
        if (submitButton) {
          submitButton.removeAttribute('aria-disabled');
          submitButton.removeAttribute('aria-busy');
        }
      }
    }

    try {
      setBusy(true);

      var formData = new FormData(form);
      var mainItem = {
        id: formData.get('id'),
        quantity: parseInt(formData.get('quantity') || '1', 10) || 1
      };
      var properties = {};
      var hasProperties = false;
      formData.forEach(function (value, name) {
        var match = /^properties\[(.*?)\]$/.exec(name);
        if (match) {
          properties[match[1]] = value;
          hasProperties = true;
        }
      });
      if (hasProperties) mainItem.properties = properties;

      var items = [];
      /* Gewählte Addon-Lampenschirme (bundles-Checkboxen) nicht verlieren */
      document
        .querySelectorAll('[form="' + cssEscape(atcFormId) + '"] input[name="bundles"]:checked')
        .forEach(function (input) {
          items.push({ id: input.value, quantity: 1 });
        });
      items.push(mainItem);
      items.push({ id: giftVariantId, quantity: 1, properties: { _gift: giftPropertyValue(modal) } });

      /* Section-Rendering wie theme.js ProductForm (Cart Drawer Update) */
      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      var config = theme.utils.fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        items: items,
        sections: sectionsToBundle.join(','),
        sections_url: window.location.pathname
      });

      fetch(theme.routes.cart_add_url, config)
        .then(function (response) {
          return response.json();
        })
        .then(function (parsedState) {
          if (parsedState.status) {
            throw new Error(parsedState.description || parsedState.message || 'cart error');
          }
          return fetch(theme.routes.cart_url, Object.assign({}, theme.utils.fetchConfig('json', 'GET')))
            .then(function (response) {
              return response.json();
            })
            .then(function (cartJson) {
              cartJson['sections'] = parsedState['sections'];
              theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cart: cartJson
              });
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsedState } }));

              closeModal(modal);
              var cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer && typeof cartDrawer.show === 'function') cartDrawer.show();
            });
        })
        .catch(function (error) {
          console.error('[gift-picker] Cart-Call fehlgeschlagen — Fallback auf normalen ATC.', error);
          closeModal(modal);
          submitNative(form);
        })
        .finally(function () {
          setBusy(false);
        });
    } catch (error) {
      /* Synchroner Fehler (z. B. theme.utils fehlt) -> normaler ATC */
      console.error('[gift-picker] Unerwarteter Fehler — Fallback auf normalen ATC.', error);
      setBusy(false);
      closeModal(modal);
      submitNative(form);
    }
  }

  /* --- 4. Warenkorb-Schnappschuss aktuell halten ------------------------ */
  /* Ohne das rechnet die Mindestanzahl mit dem Stand beim Seitenaufruf. Wird
     im Warenkorb-Drawer etwas entfernt, waere die Schwelle zu frueh erreicht
     und das Geschenk voll berechnet. Das Nachladen laeuft im Hintergrund,
     damit der ATC-Klick selbst nie auf eine Antwort wartet. */
  document.addEventListener('cart:refresh', refreshCartItems);
  document.addEventListener('ajaxProduct:added', refreshCartItems);
  (function subscribeCartUpdate(attempt) {
    if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, refreshCartItems);
      return;
    }
    /* theme.js kann nach diesem Skript laden — begrenzt nachfassen, nicht ewig. */
    if (attempt >= 20) {
      warn('theme.pubsub nicht verfügbar — Warenkorb-Stand wird nur über cart:refresh aktualisiert.');
      return;
    }
    setTimeout(function () {
      subscribeCartUpdate(attempt + 1);
    }, 250);
  })(0);
})();
